<template>
    <fieldset class="w-full flex flex-col items-center mt-2">
        <legend class="text-xxs">
            Add Comment:
        </legend>

        <textarea class="bg-gray-100 border-2 border-gray-400 focus:border-indigo-400 h-16 outline-none px-2 py-1 resize-none rounded text-black text-sm leading-snug w-full"
            ref="textarea"
            v-model="comment"
        />

        <div class="w-full flex justify-between items-center mt-2 -mb-2">
            <button class="bg-transparent hover:bg-transparent text-xs text-red-500 hover:text-red-700 cursor-pointer px-1 py-0"
                @click="clearComment"
                :aria-label="$t('Cancel adding a comment')"
            >
                {{ $t('Cancel') }}
            </button>

            <button class="text-white text-xxs uppercase px-6 py-1 rounded-sm bg-indigo-500 hover:text-indigo-100 hover:bg-indigo-700 cursor-pointer"
                @click="saveComment"
            >
                {{ $t('Post Comment') }}
            </button>
        </div>
    </fieldset>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        annotation: null,
        self_id: null,
    },

    data() {
        return {
            comment: '',
        }
    },

    methods: {
        clearComment() {
            this.comment = '';
            this.$emit('clear');
        },
        saveComment() {
            axios.patch('/users/' + this.annotation.report_user_id
                + '/reportsections/' + this.annotation.report_section_id
                + '/annotations/' + this.annotation.id,
                { comment: this.comment }
            ).then(response => {
                this.$emit('updateComments', { id: this.annotation.id, comments: response.data.comments });
            }).catch(error => {
                if (error.response.data.message) {
                    alert('Error: ' + error.response.data.message);
                }

                console.log(error.response.data);
            }).finally(() => {
                this.clearComment();
            });
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.textarea?.focus();
        })
    },
}
</script>
